<template>
  <div class="areaPolicyPage">
    <van-loading size="24px" vertical v-if="showLoading">加载中...</van-loading>
    <div class="pageMain" v-if="!showLoading">
      <div class="count" v-if="!showNonePage">
        <div v-html="documentMain" class="countHtml"></div>
        <p class="fgx" v-if="this.baseFiles.length > 1"></p>
        <div class="download main" v-if="this.baseFiles.length > 1">
          <h4 class="ggTit">{{ $t("common.affixTit") }}</h4>
          <div class="detailMian">
            <ul>
              <li
                class="clearfix downloadItem"
                v-for="item in baseFiles"
                :key="item.id"
              >
                <dl class="fl" @click="preview(item)">
                  <dt>
                    <img
                      :src="
                        getFormat(item.fileName) == 'jpg' ||
                        getFormat(item.fileName) == 'png' ||
                        getFormat(item.fileName) == 'jpeg'
                          ? item.url
                          : getFormat(item.fileName) == 'pdf'
                          ? '' + baseUrl + 'searchImg/pdf.png'
                          : getFormat(item.fileName) == 'xlsx' ||
                            getFormat(item.fileName) == 'xls'
                          ? '' + baseUrl + 'searchImg/excel.png'
                          : '' + baseUrl + 'searchImg/word.png'
                      "
                      alt
                    />
                  </dt>
                  <dd class="dtName">
                    <span> {{ item.fileName }}</span>
                    <span>{{ getMb(item.fileSize) }}</span>
                  </dd>
                  <!-- <dd class="Mb">
                    <span>{{ getMb(item.fileSize) }}</span>
                  </dd> -->
                </dl>
                <a
                  href="javascript:void(0);"
                  class="downloadBtn fr"
                  @click="downLoad(item)"
                  >{{ $t("common.downloadTit") }}</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="nonePage" v-if="showNonePage">
        <img :src="nonePng" alt />
        <p>{{ $t("common.noDataTip") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import nonePng from "@/assets/none.png";
// import { getToken } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "areaPolicy",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      showLoading: true,
      nonePng: nonePng, //默认图片
      showNonePage: false,
      documentMain: "",
      baseFiles: [],
      clientType: "", //手机类型
    };
  },
  props: {
    userId: { String },
  },
  mounted() {
    this.clientType = getDeviceType();
    this.$nextTick(function () {
      this.initRecord();
    });
  },
  methods: {
    initRecord() {
      let _this = this;
      _this.$api.User.myGridStatistics({
        uid: _this.userId,
      })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            this.getMain(res.data.objid, res.data.gridLevel);
          } else {
            _this.showLoading = false;
            _this.showNonePage = true;
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMain(objid, gridLevel) {
      let _this = this;
      _this.$api.universal.dutyArea
        .getYlycInfo({
          objid: objid,
          regionLevel: gridLevel,
          regionCode: "",
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.showLoading = false;
            if (res.data == null) {
              _this.showNonePage = true;
            } else {
              _this.documentMain = res.data.document;
              if (res.data.baseFiles.length < 1) {
                _this.baseFiles = [];
              } else {
                _this.baseFiles = res.data.baseFiles;
              }
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    downLoad(data) {
      console.log(data);
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115, data.url);
      } else {
        let dataArguments = {
          url: data.url,
          fileName: data.fileName,
          twoArguments: "",
        };
        if (
          this.getFormat(data.fileName) == "jpg" ||
          this.getFormat(data.fileName) == "png" ||
          this.getFormat(data.fileName) == "jpeg"
        ) {
          dataArguments.twoArguments = "picture";
        }
        window.webkit.messageHandlers.downLoad.postMessage(
          JSON.stringify(dataArguments)
        );
      }
    },
    preview(data) {
      //原生交互预览
      if (this.clientType == "android") {
        //安卓
        window.android.getInfo(115, JSON.stringify(data.url));
      } else {
        window.webkit.messageHandlers.preview.postMessage(JSON.stringify(data));
      }
    },
    getMb(Kb) {
      let size = "";
      size = (Kb / 1024 / 1024).toFixed(4) + "MB";
      return size;
    },
    getFormat(name) {
      //获取文件后缀
      const _index = name.lastIndexOf(".");
      return _index >= 0 ? name.substring(_index + 1, name.length) : "";
    },
    getLevel(type) {
      //获取责任区等级
      let grade = "";
      if (type == "geo_grid_sheng") {
        grade = "1";
      } else if (type == "geo_grid_shi") {
        grade = "2";
      } else if (type == "geo_grid_xian") {
        grade = "3";
      } else if (type == "geo_grid_xiang") {
        grade = "4";
      } else {
        grade = "5";
      }
      return grade;
    },
  },
  watch: {
    userId: function () {
      this.initRecord();
    },
  },
};
</script>
<style lang="less">
.areaPolicyPage {
  width: 100%;
  height: 100%;
  p.fgx {
    width: 100%;
    height: 20px;
    background-color: #f6f6f6;
  }
  h4.ggTit {
    position: relative;
    border-bottom: 1px solid #f6f6f6;
    line-height: 45px;
    padding: 0 20px;
    font-weight: 700;
    color: #35c476;
    font-size: 14px;
    z-index: 10;
    background-color: #fff;
  }
  .pageMain {
    width: 100%;
    height: 100%;
    background-color: #fff;
    position: relative;
    overflow-y: scroll;
    padding-bottom: 30px;
    .count {
      .countHtml {
        margin-top: 6px;
        padding: 0 16px 8px;

        img {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          display: block;
        }

        p {
          font-size: 14px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(3, 3, 3, 1);
          line-height: 20px;
          opacity: 0.7;
        }
      }
      .download {
        width: 100%;
        // padding: 0 16px;
        .detailMian {
          width: 100%;
          margin-top: 10px;
          padding: 0 16px;
          li.downloadItem {
            width: 100%;
            height: 50px;
            margin: 8px 0;
            padding-bottom: 10px;
            border-bottom: 1px solid #f6f6f6;
            dl {
              width: 85%;
              position: relative;

              dt {
                display: block;
                width: 40px;
                height: 40px;
                position: absolute;
                img {
                  max-width: 100%;
                  max-height: 100%;
                }
              }

              dd {
                display: block;
                font-size: 10px;
                color: #999;
              }

              dd.dtName {
                font-size: 12px;
                color: #666;

                margin-left: 50px;
                > span {
                  display: block;
                }
              }
            }
          }
          li:last-child {
            border: 0 none;
          }

          a {
            margin-top: 5px;
            display: block;
            font-size: 12px;
            color: #35c476;
            width: 30px;
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 150px;
      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>